import { Radio } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { setValueOptions } from '../../../store/actions/setting'
import { getValueOption, valueOption } from '../../../store/selectors/selectors'
import { getUrlImg } from '../../../utils/utilsFunctions'
//@ts-ignore
import s from './RadioStandart.module.scss'
export type radioValue = {
    label: string
    value: string
    imgUrl?: string
}

export type radioStandardT = {
    defaultValue?: string;
    values: radioValue[],
    parentKeySection?: unknown
}



let StyledRadioFunc: any = ({ ...props }) => styled(Radio)`
    .ant-radio-inner{
        border-color: #BBB5AA !important;
        
    }
    .ant-radio-inner::after{
        border: 5px solid #B77250 !important;
        width: 100% !important;
        height: 100% !important;
        background-color: #fff !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        ${!!props['isError'] && `border: 6px solid #DE5555 !important;`}
    }
    .ant-radio-checked::after{
        border: 1px solid #B77250 !important;
        
    }
    .ant-radio-checked .ant-radio-inner {
        border:none; 
    }
    .ant-radio-input:focus + .ant-radio-inner {
        box-shadow: 0 0 0 3px rgb(183 114 80 / 8%)  !important;
    }  
    .ant-radio + span{ 
        ${!!props['isError'] && `color: #DE5555 !important;`}
    }

     
  
`;

export const RadioStandard = ({ ...props }: any) => {

    const { values, id, parentKeySection } = props;
    const dispatch = useDispatch();

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({ idOptions: id, parentKeySection })(state));

    const onChange = (value: any) => {
        dispatch(setValueOptions({ idParams: id, valueParam: value['target']['value'], parentKeySection: parentKeySection }))
    }

    let classRadioGrup: any;

    if (props['values'][0]['imgUrl']) {
        classRadioGrup += ` ${s.groupRadio}`
    }

    return (
        <Radio.Group value={selectValue} className={classRadioGrup} onChange={onChange}  >
            {values.map((radio: radioValue) => {

                isError = selectValue === radio['value'] && isError;
                let StyledRadio = StyledRadioFunc({ isError })
                return (
                    <label className={s.radio} key={radio['label']} >
                        {radio['imgUrl'] && (
                            <img src={getUrlImg(radio['imgUrl'])} alt="" />
                        )}
                        <StyledRadio name={radio['value']} value={radio['value']}>
                            <div className={s.radioLabel}>
                                {radio['label']}
                            </div>
                        </StyledRadio>
                    </label>
                )
            })}
        </Radio.Group>
    )
}
